<!-- Loading bar -->
<fuse-loading-bar></fuse-loading-bar>

<!-- Wrapper -->
<div class="flex flex-col flex-auto w-full">
  <impersonation-banner></impersonation-banner>
  <!-- Content -->
  <div class="flex flex-col flex-auto">
    <!-- *ngIf="true" hack is required here for router-outlet to work correctly.
             Otherwise, layout changes won't be registered and the view won't be updated! -->
    <router-outlet *ngIf="true"></router-outlet>

    <!--
        <button (click)="chatDrawer.toggle()">chat with me</button>
    <fuse-drawer
      class="w-screen min-w-screen sm:w-100 sm:min-w-100 z-999"
      fixed
      [mode]="'slide'"
      [name]="'chatDrawer'"
      [position]="'right'"
      #chatDrawer>
      <div class="flex flex-col w-full overflow-auto bg-card">
        <div class="flex flex-row items-center px-6 h-20 min-h-20 text-white bg-primary">
          <mat-icon class="icon-size-7 text-current" [svgIcon]="'heroicons_solid:cog-8-tooth'"></mat-icon>
          <div class="ml-3 text-2xl font-semibold tracking-tight">Chat</div>
          <button class="ml-auto" mat-icon-button (click)="chatDrawer.close()">
            <mat-icon class="text-current" [svgIcon]="'heroicons_outline:x-mark'"></mat-icon>
          </button>
        </div>

        <div class="flex flex-col p-6">
          <div class="text-md font-semibold text-secondary">THEME</div>
          <div class="grid grid-cols-2 sm:grid-cols-3 gap-3 mt-6"></div>

          <hr class="my-8" />
        </div>
      </div>
    </fuse-drawer>
-->
  </div>
</div>
